import { supabase } from '../supabaseClient'

class SupplierService {
  createSupplier = async (payload: any): Promise<any> => {
    try {
      let { error: insertError, data } = await supabase.from('suppliers').insert(payload)

      if (insertError) {
        console.error(insertError)
      }

      return true
    } catch (error) {
      console.error({ error })
    }
  }

  deleteSupplier = async (id: string): Promise<any> => {
    try {
      const { error } = await supabase.from('suppliers').delete().eq('id', id)

      if (error) {
        console.error(error)
      }

      return true
    } catch (error) {
      console.error({ error })
    }
  }

  countSuppliers = async (): Promise<any> => {
    try {
      const { data, error } = await supabase.from('suppliers').select('id')
      if (error) {
        console.error('Error fetching total rows:', error)
      } else {
        return data?.length
      }
    } catch (e) {
      console.log(e)
    }
  }

  getPaginatedSuppliers = async (
    page: number,
    term?: string,
    sortOptions?: { sortField: string; sortDirection: 'asc' | 'desc' },
  ): Promise<any> => {
    try {
      const count = await this.countSuppliers()

      let query = supabase
        .from('suppliers')
        .select()
        .range((page - 1) * 5, page * 5 - 1)

      if (term) {
        query = query.ilike('name', `%${term}%`)
      }

      if (sortOptions?.sortField && sortOptions.sortDirection) {
        query = query.order(sortOptions.sortField, {
          ascending: sortOptions.sortDirection === 'asc',
        })
      }

      const { data, error } = await query
      if (error) {
        console.error(error)
      }
      return {
        data,
        count,
      }
    } catch (error) {
      console.error({ error })
    }
  }
}

const supplierService = new SupplierService()

export default supplierService
